module.exports = __webpack_public_path__ + "static/media/ken.e5d15237.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/ken.png
// module id = 307
// module chunks = 0